import { api, apiUrl, resolveTenantSlug, tokens } from './api';

export interface Branding {
  name: string;
  logoUrl: string | null;
  primaryColor: string;
  accentColor: string;
  supportEmail: string | null;
  tagline: string | null;
  loginImageUrl: string | null;
  loginLayout: string;   // Centered | SplitImage | Minimal
}

export const LOGIN_LAYOUTS = ['Centered', 'SplitImage', 'Minimal'] as const;

async function uploadImage(path: string, file: File): Promise<Branding> {
  const fd = new FormData();
  fd.append('file', file);
  const slug = resolveTenantSlug();
  const res = await fetch(apiUrl(path), {
    method: 'POST',
    headers: {
      ...(slug ? { 'X-Tenant': slug } : {}),
      ...(tokens.access() ? { Authorization: `Bearer ${tokens.access()}` } : {}),
    },
    body: fd,
  });
  if (!res.ok) throw new Error('Upload failed');
  return (await res.json()) as Branding;
}

export const brandingApi = {
  get: () => api.get<Branding>('/api/branding/'),
  update: (b: {
    primaryColor?: string; accentColor?: string; supportEmail?: string | null;
    tagline?: string | null; loginLayout?: string;
  }) => api.put<Branding>('/api/branding/', b),
  uploadLogo: (file: File) => uploadImage('/api/branding/logo', file),
  uploadLoginImage: (file: File) => uploadImage('/api/branding/login-image', file),
};
